import React from "react";
import clsx from "clsx";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import { useSetLocationData } from "~/hooks/locationData";

import Button from "~/shared/ui/Fields/Button";

import Default from "~/components/Icons/icon-default";
import Delete from "~/components/Icons/delete-cross";
import s from "./TableRow.less";

interface IProps {
  options: string[];
  optionChildren: string[];
  type: string;
  btnEdit?: boolean;
  setValue?;
  btnView?: boolean;
  btnDel?: boolean;
  item;
  selectParent;
}

const EditorIndicatorsTableRow: React.FC<IProps> = ({
  options = [],
  optionChildren = [],
  item = {},
  selectParent,
  setValue,
  btnEdit = false,
  btnView = false,
  btnDel = false,
  type,
}) => {
  const { t } = useTranslation();
  const setData = useSetLocationData();
  const withBtns = btnEdit || btnDel || btnView;
  const isEditorVersion = type === "editor.versions";
  const isDelete =
    isEditorVersion &&
    new Date().toString() < format(new Date(item.dateBegin), "dd.MM.yyyy");

  const openEditModal = () => {
    setData("openModal", "Edit", "currentId", item.id);
  };
  const openViewModal = () => {
    setData("openChildModal", "View", "currentId", item.id);
  };
  const openDelModal = () => {
    setData("openModal", "Sure", "currentId", item.id);
  };

  const openEditName = () => {
    setValue(item.GroupOne);
    setData("openModal", "EditName");
  };

  return (
    <>
      {item.isOneParrent && (
        <tr
          className={clsx(s.row_tr, {
            [s.row_group]: item.isOneParrent,
          })}
        >
          <td colSpan={options.length}>{item.GroupOne}</td>
          <td>
            <Button small txtBtn={t("ui.btn_edit")} onClick={openEditName}>
              <Default />
            </Button>
          </td>
        </tr>
      )}

      <tr className={clsx(s.row_tr)}>
        {options?.map((optionName, index) => (
          <TDResolver {...{ optionName, optionChildren, item }} key={index} />
        ))}
        {withBtns && (
          <td className={s.with_btn}>
            {btnEdit && (
              <div className={s.cont}>
                <Button small txtBtn={t("ui.btn_edit")} onClick={openEditModal}>
                  <Default />
                </Button>
              </div>
            )}

            {btnView && (
              <div
                className={clsx({
                  [s.cont]: true,
                  [s.btn_view]: true,
                  [s.active]: item.countDC === "All",
                })}
              >
                <Button
                  small
                  txtBtn={t("ui.view")}
                  onClick={openViewModal}
                  customClassName={clsx({
                    [s.wide_btn]: true,
                  })}
                >
                  <Default />
                </Button>
              </div>
            )}

            {(btnDel || isDelete) && (
              <div className={s.cont}>
                <Button
                  small
                  txtBtn={t("ui.btn_del")}
                  empty
                  onClick={openDelModal}
                >
                  <Delete />
                </Button>
              </div>
            )}
          </td>
        )}
      </tr>
    </>
  );
};
export default EditorIndicatorsTableRow;

interface ITDResolverProps {
  optionName: string;
  item: any;
  optionChildren: string[];
}
const TDResolver = ({ optionName, item, optionChildren }: ITDResolverProps) => {
  switch (optionName) {
    case "combineTraining":
    case "combineCertification":
      return (
        <td key={optionName} data-option_name={optionName}>
          <div>
            <span className={s.cont}>{item[optionName] ? "Да" : "Нет"}</span>
          </div>
        </td>
      );
    default:
      return (
        <td key={optionName} data-option_name={optionName}>
          <div>
            <span className={s.cont}>{item[optionName]}</span>
            {optionChildren.length > 0 &&
              optionChildren.includes(optionName) && (
                <div className={s.cont_under}>
                  {item[optionName + "Period"]}
                </div>
              )}
          </div>
        </td>
      );
  }
};
